import classNames from 'classnames';
import type { ReactNode } from 'react';
import React from 'react';
import type { IntlShape } from 'react-intl';

type DeleteMessageProps = {
  intl: IntlShape
  className?: string;
  content?: ReactNode;
}

const DeleteMessage: React.FC<DeleteMessageProps> = ({ content, className, intl }) => (
  <div className={classNames('d-flex flex-column gap-2', className)}>
    {content}
    <p className="mb-0">
      {intl.formatMessage({ id: 'page.config.dealer_general.templates.deleteTemplate.warning', defaultMessage: 'We will not be able to recover it after it has been deleted.' })}
    </p>
  </div>
);

export default DeleteMessage;
